<template>
  <div class="reportings-list">
    <b-alert v-model="hasError" variant="danger">
      {{ errorMessage }}
    </b-alert>

    <dx-data-grid
      :ref="dataGridEventsRG"
      id="gridContainerReportingEvent"
      :data-source="dataSource"
      :allow-column-reordering="true"
      :allow-column-resizing="true"
      :column-min-width="120"
      columnResizingMode="widget"
      :show-borders="true"
      :showColumnLines="true"
      :showRowLines="true"
      key-expr="field_001"
      :no-data-text="$t('general.noEntries')"
      :column-auto-width="false"
      :word-wrap-enabled="true"
      :hover-state-enabled="true"
      @contentReady="contentReady"
      :remote-operations="true"
      :sync-lookup-filter-values="false"
    >
      <dx-scrolling
        mode="virtual"
        row-rendering-mode="virtual"
      />
      <dx-paging :page-size="pageSize"/>
      <dx-filter-panel :visible="true"/>
      <dx-filter-row
        :visible="true"
        apply-filter=""
      />
      <dx-header-filter
        :visible="true"
      />
      <dx-column-chooser
        :enabled="true"
        mode="select"
      >
        <dx-column-chooser-search
          :enabled="true"
        />
      </dx-column-chooser>
      <dx-search-panel
        :visible="true"
        :width="320"
        placeholder="Search..."
      />
      <dx-column
        data-field="profile.cRMAddress.field_001"
        :caption="$t('funding.list.id')"
        :width="120"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="profile.cRMAddress.company"
        :caption="$t('event.detail.company')"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="profile.oneLiner_en"
        :caption="$t('event.detail.oneLinerEn')"
        :width="450"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="profile.description_open_en"
        :caption="$t('event.detail.descriptionEN')"
        :width="600"
        :visible="false"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="profile.cRMAddress.streetB"
        :caption="$t('event.detail.streetB')"
        :visible="false"
        :width="150"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="profile.cRMAddress.zipB"
        :caption="$t('event.detail.zipB')"
        :visible="false"
        :width="80"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="profile.cRMAddress.cityB"
        :caption="$t('event.detail.cityB')"
        :width="200"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="profile.cRMAddress.countryBId"
        :caption="$t('event.detail.countryB')"
        :width="150"
      >
        <dx-lookup
          :data-source="countryTypes"
          display-expr="land"
          value-expr="field_001"
        />
      </dx-column>
      <dx-column
        data-field="profile.cRMAddress.incorporationDate"
        :caption="$t('event.detail.incorporationDate')"
        alignment="right"
        data-type="date"
        format="dd.MM.yyyy"
        :width="100"
        :allow-header-filtering="false"
      />
      <dx-column
        :caption="$t('event.detail.uniFaculty')"
        :visible="false"
        :width="200"
        :allow-header-filtering="false"
      >
        <dx-column
          data-field="profile.cRMAddress.cRMUniFaculty.universityIDId"
          :caption="$t('event.detail.university')"
          :width="200"
          :allow-hiding="false"
          :allow-header-filtering="false"
        >
          <dx-lookup
            :data-source="universityTypes"
            display-expr="university"
            value-expr="field_001"
            :allow-clearing="true"
          />
        </dx-column>
        <dx-column
          data-field="profile.cRMAddress.universityFacultyIDId"
          :caption="$t('event.detail.faculty')"
          :allow-hiding="false"
          :width="200"
          :allow-header-filtering="false"
        >
          <dx-lookup
            :data-source='getFilteredFaculties'
            display-expr='departementFaculty'
            value-expr='field_001'
          />
        </dx-column>
      </dx-column>
      <dx-column
        data-field="profile.cRMAddress.firstname"
        :caption="$t('event.detail.firstname')"
        :width="150"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="profile.cRMAddress.lastname"
        :caption="$t('event.detail.lastname')"
        :width="150"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="profile.cRMAddress.mobileB"
        :caption="$t('event.detail.mobile')"
        :visible="false"
        :width="150"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="profile.cRMAddress.phoneB"
        :caption="$t('event.detail.phoneB')"
        :visible="false"
        :width="150"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="profile.cRMAddress.emailB1"
        :caption="$t('event.detail.email')"
        :width="150"
        :visible="false"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="profile.cRMAddress.emailB2"
        :caption="$t('event.detail.emailB2')"
        :visible="false"
        :width="150"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="profile.cRMAddress.facebookB"
        :caption="$t('event.detail.facebookB')"
        :visible="false"
        :width="150"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="profile.cRMAddress.linkedInB"
        :caption="$t('event.detail.linkedInB')"
        :visible="false"
        :width="150"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="profile.cRMAddress.twitterB"
        :caption="$t('event.detail.twitterB')"
        :visible="false"
        :width="150"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="profile.cRMAddress.instagramB"
        :caption="$t('event.detail.instagramB')"
        :visible="false"
        :width="150"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="profile.cRMAddress.similarwebB"
        :caption="$t('event.detail.similarwebB')"
        :visible="false"
        :width="150"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="profile.cRMAddress.alexaB"
        :caption="$t('event.detail.alexaB')"
        :visible="false"
        :width="150"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="profile.cRMAddress.salutationId"
        :caption="$t('event.detail.salutationId')"
        :width="150"
        :visible="false"
      >
        <dx-lookup
          :data-source='salutationTypes'
          :display-expr='getDisplayExpr'
          value-expr='ansprechzeile_id'
        />
      </dx-column>
      <dx-column
        data-field="profile.cRMAddress.permalink"
        cell-template="permalink-template"
        :caption="$t('event.detail.startuplink')"
        :allow-editing="false"
        :width="180"
        :visible="false"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="profile.cRMAddress.internetB"
        :caption="$t('event.detail.internet')"
        :width="150"
        :visible="false"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="profile.cRMAddress.startupPhaseId"
        :caption="$t('event.detail.startupPhase')"
        :width="150"
        :visible="false"
      >
        <dx-lookup
          :data-source="startupPhaseTypes"
          display-expr="startupphase"
          value-expr="field_001"
          :allow-clearing="true"
        />
      </dx-column>
      <dx-column
        v-if="checkAdmin(currentUser.mitarbeiterId)"
        :caption="$t('event.detail.totalFunding')"
        :calculate-cell-value="calcTotal"
        :format="totalFormat"
        :allow-filtering="false"
        :allow-sorting="false"
        :width="150"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="profile.cRMAddress.technologyId"
        :caption="$t('event.detail.technology')"
        :width="200"
      >
        <dx-lookup
          :data-source="brancheTypes"
          display-expr="brancheEn"
          value-expr="field_001"
          :allow-clearing="true"
        />
      </dx-column>
      <dx-column
        data-field="profile.cRMAddress.unispinoffId"
        :caption="$t('event.detail.unispinoff')"
        :visible="false"
        :width="200"
      >
        <dx-lookup
          :data-source="universityTypes"
          display-expr="university"
          value-expr="field_001"
          :allow-clearing="true"
        />
      </dx-column>
      <dx-column
        data-field="profile.cRMAddress.priovlabId"
        :caption="$t('event.detail.priovlabId')"
        :visible="false"
        :width="100"
      >
        <dx-lookup
          :data-source="priovlabTypes"
          display-expr="status"
          value-expr="field_001"
          :allow-clearing="true"
        />
      </dx-column>
      <dx-column
        data-field="profile.cRMAddress.prioXMasId"
        :caption="$t('event.detail.prioXMasId')"
        :visible="false"
        :width="100"
      >
        <dx-lookup
          :data-source="priovlabxmasTypes"
          display-expr="statusxmas"
          value-expr="field_001"
          :allow-clearing="true"
        />
      </dx-column>
      <dx-column
        data-field="profile.cRMAddress.vKCaseStatus"
        :caption="$t('event.detail.vKCaseStatus')"
        :visible="false"
        :width="150"
      >
        <dx-lookup
          :data-source="vkCaseStatusTypes"
          display-expr="casestatus"
          value-expr="field_001"
          :allow-clearing="true"
        />
      </dx-column>
      <dx-column
        data-field="profile.cRMAddress.vKacademiclinkId"
        :caption="$t('event.detail.vKacademiclink')"
        :visible="false"
        :width="200"
      >
        <dx-lookup
          :data-source="universityTypes"
          display-expr="university"
          value-expr="field_001"
          :allow-clearing="true"
        />
      </dx-column>
      <dx-column
        data-field="profile.cRMAddress.tradeRegisterNr"
        :caption="$t('event.detail.tradeRegisterNr')"
        :visible="false"
        :width="200"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="profile.cRMAddress.legalFormId"
        :caption="$t('event.detail.legalFormId')"
        :visible="false"
        :width="150"
        :allow-header-filtering="false"
      >
        <dx-lookup
          :data-source='rechtsformTypes'
          display-expr='rechtsform'
          value-expr='field_001'
          :allow-clearing="true"
        />
      </dx-column>
      <dx-column
        data-field="profile.cRMAddress.streetP"
        :caption="$t('event.detail.streetP')"
        :visible="false"
        :width="150"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="profile.cRMAddress.zipP"
        :caption="$t('event.detail.zipP')"
        :visible="false"
        :width="80"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="profile.cRMAddress.cityP"
        :caption="$t('event.detail.cityP')"
        :visible="false"
        :width="150"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="profile.cRMAddress.countryPId"
        :caption="$t('event.detail.countryP')"
        :visible="false"
        :width="200"
      >
        <dx-lookup
          :data-source="countryTypes"
          display-expr="land"
          value-expr="field_001"
        />
      </dx-column>
      <dx-column
        data-field="profile.cRMAddress.mobileP"
        :caption="$t('event.detail.mobileP')"
        :visible="false"
        :width="150"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="profile.cRMAddress.phoneP"
        :caption="$t('event.detail.phoneP')"
        :visible="false"
        :width="150"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="profile.cRMAddress.emailP1"
        :caption="$t('event.detail.emailP1')"
        :visible="false"
        :width="150"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="profile.cRMAddress.emailP2"
        :caption="$t('event.detail.emailP2')"
        :visible="false"
        :width="150"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="profile.cRMAddress.facebookP"
        :caption="$t('event.detail.facebookP')"
        :visible="false"
        :width="150"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="profile.cRMAddress.linkedInP"
        :caption="$t('event.detail.linkedInP')"
        :visible="false"
        :width="150"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="profile.cRMAddress.twitterP"
        :caption="$t('event.detail.twitterP')"
        :visible="false"
        :width="150"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="profile.cRMAddress.birthday"
        :caption="$t('event.detail.birthday')"
        data-type="date"
        format="dd.MM.yyyy"
        :visible="false"
        alignment="right"
        :width="100"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="profile.cRMAddress.languageId"
        :caption="$t('event.detail.languageId')"
        :visible="false"
        :width="100"
      >
        <dx-lookup
          :data-source="languagesTypes"
          display-expr="spracheEN"
          value-expr="field_001"
        />
      </dx-column>
      <dx-column
        data-field="profile.cRMAddress.educationId"
        :caption="$t('event.detail.educationId')"
        :visible="false"
        :width="150"
      >
        <dx-lookup
          :data-source="educationTypes"
          display-expr="education"
          value-expr="field_001"
          :allow-clearing="true"
        />
      </dx-column>
      <dx-column
        data-field="profile.cRMAddress.position"
        :caption="$t('event.detail.position')"
        :visible="false"
        :width="180"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="profile.cRMAddress.kantonId"
        :caption="$t('event.detail.kantonId')"
        :visible="false"
        :width="150"
      >
        <dx-lookup
          :data-source="cantonTypes"
          display-expr="kantonEN"
          value-expr="field_001"
          :allow-clearing="true"
        />
      </dx-column>
      <dx-column
        data-field="profile.cRMAddress.sUTkrTradeRegUID"
        :caption="$t('event.detail.sutkruid')"
        :visible="false"
        :width="100"
        :allow-header-filtering="false"
      />
      <dx-column
        v-if="checkAdmin(currentUser.mitarbeiterId)"
        data-field="profile.pEOPLEFemaleFounders"
        :caption="$t('event.detail.peoplefemalefounders')"
        :visible="false"
        :width="150"
        :allow-header-filtering="false"
      />
      <dx-column
        v-if="checkAdmin(currentUser.mitarbeiterId)"
        data-field="profile.pEOPLEMaleFounders"
        :caption="$t('event.detail.peoplemalefounders')"
        :visible="false"
        :width="150"
        :allow-header-filtering="false"
      />
      <dx-column
        v-if="checkAdmin(currentUser.mitarbeiterId)"
        data-field="profile.peopleEPFLFac"
        :caption="$t('event.detail.peopleEPFLFac')"
        :visible="false"
        :width="150"
        :allow-header-filtering="false"
      />
      <dx-column
        v-if="checkAdmin(currentUser.mitarbeiterId)"
        data-field="profile.peopleEPFLLab"
        :caption="$t('event.detail.peopleEPFLLab')"
        :visible="false"
        :width="150"
        :allow-header-filtering="false"
      />
      <dx-column
        v-if="checkAdmin(currentUser.mitarbeiterId)"
        data-field="profile.peopleEPFLProf"
        :caption="$t('event.detail.peopleEPFLProf')"
        :visible="false"
        :width="150"
        :allow-header-filtering="false"
      />
      <dx-column
        v-if="checkAdmin(currentUser.mitarbeiterId)"
        data-field="profile.totalEmployee"
        :caption="$t('event.detail.totalEmployee')"
        :visible="false"
        :allow-editing="false"
        :width="150"
        :allow-header-filtering="false"
      />
      <dx-column
        v-if="checkAdmin(currentUser.mitarbeiterId)"
        data-field="profile.changeDate"
        :caption="$t('event.detail.changeDate')"
        data-type="date"
        format="dd.MM.yyyy"
        alignment="right"
        :visible="false"
        :allow-editing="false"
        :width="150"
        :allow-header-filtering="false"
      />
      <dx-column
        v-if="checkAdmin(currentUser.mitarbeiterId)"
        data-field="profile.turnOver"
        :caption="$t('event.detail.turnover')"
        :visible="false"
        :allow-editing="false"
        :width="150"
        :allow-header-filtering="false"
      />
      <dx-column
        v-if="checkAdmin(currentUser.mitarbeiterId)"
        data-field="profile.ownedCopyrights"
        :caption="$t('event.detail.ownedCopyrights')"
        :visible="false"
        :allow-editing="false"
        :width="150"
        :allow-header-filtering="false"
      />
      <dx-column
        v-if="checkAdmin(currentUser.mitarbeiterId)"
        data-field="profile.ownedTrademarks"
        :caption="$t('event.detail.ownedTrademarks')"
        :visible="false"
        :allow-editing="false"
        :width="150"
        :allow-header-filtering="false"
      />
      <dx-column
        v-if="checkAdmin(currentUser.mitarbeiterId)"
        data-field="profile.pendingPatents"
        :caption="$t('event.detail.pendingPatents')"
        :visible="false"
        :allow-editing="false"
        :width="150"
        :allow-header-filtering="false"
      />
      <dx-column
        v-if="checkAdmin(currentUser.mitarbeiterId)"
        data-field="profile.grantedPatents"
        :caption="$t('event.detail.grantedPatents')"
        :visible="false"
        :allow-editing="false"
        :width="150"
        :allow-header-filtering="false"
      />
      <dx-toolbar>
        <dx-item
          location="before"
          template="totalGroupCount"
        />
        <dx-item
          name="searchPanel"
        />
        <dx-item
          location="after"
          template="actionmenu"
        />
      </dx-toolbar>
      <template #permalink-template="{ data }">
        <a v-if="data.data.profile.cRMAddress && data.data.profile.cRMAddress.cRMAdresseJOINRolles.length" :href="data.data.profile.cRMAddress.permalink ? `https://www.startup.ch/${data.data.profile.cRMAddress.permalink}`: ``" target="_blank">{{data.data.profile.cRMAddress.permalink}}</a>
      </template>
      <template #totalGroupCount>
        <div class="informer" v-if="initTotalCount != 0">
          <span class="count">{{ totalDevExpress }} results out of {{ initTotalCount }} records</span>
        </div>
      </template>
      <template #actionmenu>
        <div>
          <v-menu
            offset-y
            bottom
            left
            content-class="toolbar-action-menu"
          >
            <template v-slot:activator="{ attrs, on }">
              <v-btn
                color="secondary"
                v-bind="attrs"
                v-on="on"
              >
                <i class="fas fa-cog"></i> Actions
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item
                link
                @click="openColumnChooser"
              >
                <v-list-item-title><i class="fas fa-columns mr-1"></i> Column Chooser</v-list-item-title>
              </v-list-item>
              <v-list-item
                link
                @click="onExporting"
              >
                <v-list-item-title><i class="fas fa-file-excel mr-2"></i> Excel Export</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </template>
    </dx-data-grid>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import { exportDataGrid } from 'devextreme/excel_exporter'
  import ExcelJS from 'exceljs'
  import saveAs from 'file-saver'
  import { createCustomStore } from '@/store/helpers/remoteOperation.js'
  import { errorHandler } from '@/helpers/formHelper.js'
  import moment from 'moment'
  import { isAdmin } from '@/helpers/auth.js'
  import {
    DxDataGrid,
    DxColumn,
    DxScrolling,
    DxSearchPanel,
    DxColumnChooser,
    DxColumnChooserSearch,
    DxHeaderFilter,
    DxFilterPanel,
    DxFilterRow,
    DxLookup,
    DxPaging,
    DxToolbar,
    DxItem
  } from 'devextreme-vue/data-grid'

  const dataGridEventsRG = 'dataGrid'

  export default {
    components: {
      DxDataGrid,
      DxColumn,
      DxScrolling,
      DxSearchPanel,
      DxFilterPanel,
      DxColumnChooser,
      DxColumnChooserSearch,
      DxHeaderFilter,
      DxFilterRow,
      DxLookup,
      DxPaging,
      DxToolbar,
      DxItem
    },
    data () {
      return {
        hasError: false,
        errorMessage: '',
        totalFormat: { style: 'currency', currency: 'CHF', useGrouping: true, minimumSignificantDigits: 3 },
        totalCount: 0,
        totalDevExpress: 0,
        initTotalCount: 0,
        dataGridEventsRG,
        sectorsHeaderFilter: [],
        investorsHeaderFilter: [],
        awardsHeaderFilter: [],
        publicRoundValues: [{ key: '2', displayValue: '' }, { key: '1', displayValue: 'Yes' }],
        pageSize: 50,
        currentEditingRowData: null,
        currentDate: new Date()
      }
    },
    props: {
      rgFilter: {
        type: Number
      }
    },
    created () {
      this.getBasicValues('basicValues/GET_FACULTY_UNIVERSITY_TYPES', this.facultyUniversityTypes)
      this.getBasicValues('basicValues/GET_UNIVERSITY_TYPES', this.universityTypes)
      this.getBasicValues('basicValues/GET_BRANCHE_TYPES', this.brancheTypes)
      this.getBasicValues('basicValues/GET_STARTUPHASE_TYPES', this.startupPhaseTypes)
      this.getBasicValues('basicValues/GET_COUNTRY_TYPES', this.countryTypes)
      this.getBasicValues('basicValues/GET_CASEQUALITY_TYPES', this.casequalityTypes)
      this.getBasicValues('basicValues/GET_AFFIRMATION_TYPES', this.affirmationTypes)
      this.getBasicValues('basicValues/GET_RECHTSFORM_TYPES', this.rechtsformTypes)
      this.getBasicValues('basicValues/GET_LANGUAGES_TYPES', this.languagesTypes)
      this.getBasicValues('basicValues/GET_EDUCATION_TYPES', this.educationTypes)
      this.getBasicValues('basicValues/GET_CANTON_TYPES', this.cantonTypes)
      this.getBasicValues('basicValues/GET_SALUTATION_TYPES', this.salutationTypes)
      this.getBasicValues('basicValues/GET_PRIOVLAB_TYPES', this.priovlabTypes)
      this.getBasicValues('basicValues/GET_PRIOVLABXMAS_TYPES', this.priovlabxmasTypes)
      this.getBasicValues('basicValues/GET_PROFILCATEGORY_TYPES', this.profilcategoryTypes)
      this.getBasicValues('basicValues/GET_VKCASESTATUS_TYPES', this.vkCaseStatusTypes)
      this.initStore()
    },
    mounted () {
      this.defaultState = JSON.stringify(this.dataGrid.state())
    },
    methods: {
      initStore () {
        const key = 'field_001'
        this.dataSource = createCustomStore({ key, self: this, methodName: 'getEvents', root: this.$root })
      },
      contentReady () {
        this.totalDevExpress = this.dataGrid.totalCount()
        if (this.initTotalCount === 0) {
          this.initTotalCount = this.dataGrid.totalCount()
        }
        // exporting is only enabled if resuts are less than 8'000, because of performance reasons
        /* const excelExporter = document.getElementsByClassName('dx-datagrid-export-button')
        if (this.totalDevExpress <= 8000) {
          excelExporter[0].classList.remove('disable-exporting')
        } else {
          excelExporter[0].classList.add('disable-exporting')
        } */
      },
      async getEvents (gqlOptions) {
        this.hasError = false
        this.$Progress.start()
        const gqlOptionsAndFilter = {
          gqlOptions,
          rgId: this.rgFilter
        }

        try {
          const data = await this.$store.dispatch('event/GET_EVENTS_BY_REPORTINGGROUP', gqlOptionsAndFilter)

          const { items, totalCount } = data.data.response

          this.totalCount = totalCount
          this.$Progress.finish()

          return {
            data: items,
            totalCount
          }
        } catch (err) {
          errorHandler(this, err)
          console.error(err)
        }
      },
      getFilteredFaculties (options) {
        if (options.data && options.data.profile.cRMAddress.cRMUniFaculty !== null) {
          return {
            store: this.facultyUniversityTypes,
            filter: options.data ? ['cRMUniUniversity.field_001', '=', options.data.profile.cRMAddress.cRMUniFaculty.universityIDId] : null
          }
        } else {
          return {
            store: this.facultyUniversityTypes,
            filter: options.data ? ['cRMUniUniversity.field_001', '=', -1] : null
          }
        }
      },
      getDisplayExpr (item) {
        return item.geschlecht_PopupExtension ? `${item.ansprechzeile} ${item.geschlecht_PopupExtension}` : `${item.ansprechzeile}`
      },
      publicRoundCellValue (rowData) {
        return rowData.privacyJoin === '1' ? 'Yes' : null
      },
      calculateSectors (rowData) {
        let listOfSectors = ''
        if (rowData.profile && rowData.profile.pROFILProfilJOINCategories.length) {
          listOfSectors = Array.prototype.map.call(rowData.profile.pROFILProfilJOINCategories, function (item) { if (item.pROFILCategory) { return item.pROFILCategory.kategorieDE } else { return '' } }).join(', ')
        }
        return listOfSectors
      },
      calculateInvestors (rowData) {
        let listOfInvestors = ''
        if (rowData.cRMFundingJOINProfilProfileV2s) {
          listOfInvestors = Array.prototype.map.call(rowData.cRMFundingJOINProfilProfileV2s, function (item) { if (item.profil_idId) { return item.profile.cRMAddress.company } else { return '' } }).join(', ')
        }
        return listOfInvestors
      },
      calculateAwards (rowData) {
        let listOfAwards = ''
        if (rowData.profile && rowData.profile.cRMAddress && rowData.profile.cRMAddress.cONTESTWinners) {
          listOfAwards = Array.prototype.map.call(rowData.profile.cRMAddress.cONTESTWinners, function (item) { if (item.cONTESTExecution && item.cONTESTExecution.cONTESTContest.category_idId === 1) { return item.cONTESTExecution.contest_release } else { return '' } }).join(', ')
        }
        return listOfAwards
      },
      calcTotal (rowData) {
        let total = 0
        if (rowData.profile) {
          if (rowData.profile.cRMFundingProfileV2s) {
            // statusId 2 = Closed, InvestmentStage 10 = Trade Sale, InvestmentType 9 = Loan, 15 = Revenue
            rowData.profile.cRMFundingProfileV2s.forEach(fund => {
              if (fund.statusId === 2 && fund.investmentsStage !== 10 &&
                ![9, 15].includes(fund.investmentsTypeId)) { (total += fund.moneyinCHF) }
            })
          }
        }
        return total
      },
      onExporting () {
        this.$store.commit('fundings/SET_EXPORT_TOTAL_COUNT', null)
        this.$store.commit('fundings/SET_EXPORT_TOTAL_COUNT', this.totalCount)
        const workbook = new ExcelJS.Workbook()
        const worksheet = workbook.addWorksheet('Startups')
        exportDataGrid({
          component: this.dataGrid,
          worksheet: worksheet,
          autoFilterEnabled: true
        }).then(() => {
          workbook.xlsx.writeBuffer().then((buffer) => {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${moment(this.currentDate).format('DD.MM.YYYY')}-Startups.xlsx`)
          })
        })
        this.dataGrid.cancel = true
      },
      async getBasicValues (storePath, storeValue) {
        if (storeValue.length === 0) {
          try {
            const { errors } = await this.$store.dispatch(storePath)
            if (errors) throw errors
          } catch (err) {
            this.hasError = true
            this.errorMessage = this.$t('formError.unknownwError')
            setTimeout(() => {
              this.hasError = false
            }, 5000)
            console.error(err)
          }
        }
      },
      openColumnChooser () {
        this.dataGrid.showColumnChooser()
      },
      checkAdmin (id) {
        return isAdmin(id)
      }
    },
    computed: {
      ...mapGetters({
        items: 'fundings/FUNDINGS',
        facultyUniversityTypes: 'basicValues/FACULTY_UNIVERSITY_TYPES',
        universityTypes: 'basicValues/UNIVERSITY_TYPES',
        brancheTypes: 'basicValues/BRANCHE_TYPES',
        startupPhaseTypes: 'basicValues/STARTUPHASE_TYPES',
        crmEvent: 'event/BESTELLUNGEN',
        countryTypes: 'basicValues/COUNTRY_TYPES',
        casequalityTypes: 'basicValues/CASEQUALITY_TYPES',
        affirmationTypes: 'basicValues/AFFIRMATION_TYPES',
        rechtsformTypes: 'basicValues/RECHTSFORM_TYPES',
        languagesTypes: 'basicValues/LANGUAGES_TYPES',
        educationTypes: 'basicValues/EDUCATION_TYPES',
        cantonTypes: 'basicValues/CANTON_TYPES',
        salutationTypes: 'basicValues/SALUTATION_TYPES',
        priovlabTypes: 'basicValues/PRIOVLAB_TYPES',
        priovlabxmasTypes: 'basicValues/PRIOVLABXMAS_TYPES',
        profilcategoryTypes: 'basicValues/PROFILCATEGORY_TYPES',
        vkCaseStatusTypes: 'basicValues/VKCASESTATUS_TYPES'
      }),
      ...mapState({
        currentUser: state => state.user.currentUser
      }),
      dataGrid: function () {
        return this.$refs[dataGridEventsRG].instance
      }
    }
  }
</script>
<style lang="scss">
#gridContainerReportingEvent {
    height: 60vh;
    margin-bottom: 0;
}

.btn-pdl {
  margin: 0 0 0 5px;
}

.dx-datagrid-export-button {
  &.disable-exporting {
    pointer-events: none;

    .dx-icon-xlsxfile {
      color: lightgray;
    }
  }
}

.reportings-list {
  margin-top: 3rem;
}

</style>
